export const assetsStates = {
  assetsRoot: 'app.assets',
  assetsHome: 'app.assets.home',
  assetsCreate: 'app.assets.create',
  assetsDataTagsTaggables: 'app.assets.data-tags-taggables',
  assetsDataTagsManage: 'app.assets.data-tags-manage',
};



// WEBPACK FOOTER //
// ./src/js/assets/router-config.js